import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { client } from '@authy/lib-client/trpc'

import { appState } from '@/appState'
import { rootRoute as baseRoute } from '@/tenant/root'

export const homeRoute = createRoute({
    getParentRoute: () => baseRoute,
    path: '/',
    component: lazyRouteComponent(() => import('./Home'), 'Home'),
    loader: ({ abortController }) =>
        client.tenants.getTenantOverview.query(
            { tenantId: appState.tenant!._id.toString() },
            { signal: abortController.signal }
        ),
})
